import { ca } from '@cian/analytics';
import { IJsonQuery } from '../../types/jsonQuery/jsonQuery';
import { IPage } from '../../types/page';

interface ITrackingTag {
  position: number;
  jsonQuery: IJsonQuery;
}

interface IPromoTagsSelectParams {
  page: IPage;
  tags: ITrackingTag[];
  sc: string;
}

/**
 * Отправка события c тэгами, которые юзер выбрал, но при этом не начал поиск
 * Отправляется по закрытию попапа, для любых тэгов, если пользователь не начал поиск
 * https://conf.cian.tech/pages/viewpage.action?pageId=1311539818
 * @param {IPromoTagsSelectParams} params - Параметры события
 */
export const trackPromoTagsSelect = (params: IPromoTagsSelectParams) => {
  const { page, tags, sc } = params;

  ca('eventSite', {
    action: 'Select',
    category: 'Promo',
    label: 'Tags',
    name: 'oldevent',
    page: {
      ...page,
      extra: { tags },
    },
    sc,
  });
};
